import { render, staticRenderFns } from "./LayoutDetalhes.vue?vue&type=template&id=9fbc8bb2"
import script from "./LayoutDetalhes.vue?vue&type=script&lang=js"
export * from "./LayoutDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports